function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ClaimSelectionFromDateField from './ClaimSelectionFromDateField';
import { Col, Form, Row, Table, Button } from 'react-bootstrap';
import { Button as SubmittButton } from '@rd-web-markets/shared/dist/util/buttons';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
const ClaimsSelectionFieldFullDate = _ref => {
  let {
    toggleInclude,
    claims,
    includeSingleClaim,
    loading,
    setFromDate,
    setClaims
  } = _ref;
  const deselectAllClaims = () => {
    const updatedClaims = claims.map(claim => _objectSpread(_objectSpread({}, claim), {}, {
      include: false
    }));
    setClaims(updatedClaims);
  };
  const hasIncludedClaims = claims.some(claim => claim.include === true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), !includeSingleClaim && hasIncludedClaims && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    onClick: deselectAllClaims
  }, "Deselect All"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Table, {
    className: "table table-hover"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-primary app-fs-table-header"
  }, /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Name"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "From Date"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "To Date"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Include?"))), /*#__PURE__*/React.createElement("tbody", null, claims.map((claim, index) => /*#__PURE__*/React.createElement("tr", {
    key: index
  }, /*#__PURE__*/React.createElement("td", null, claim.kimble_name), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ClaimSelectionFromDateField, {
    claim: claim,
    setFromDate: setFromDate
  })), /*#__PURE__*/React.createElement("td", null, createTimezonedDate(claim.to_date, true).toCustomLocaleDateString()), includeSingleClaim ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(SubmittButton, {
    disabled: !claim.from_date,
    variant: "info",
    size: "sm",
    loading: loading,
    onClick: () => toggleInclude(claim)
  }, "Select ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))) : /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "include",
    disabled: !claim.from_date,
    checked: claim.include,
    value: claim.include,
    onChange: e => toggleInclude(e, index)
  })))))))));
};
export default ClaimsSelectionFieldFullDate;